import Actions from '../../../constants/Actions';
import AccountUpdateTypes from './AccountUpdateTypes';

export async function editAccount(context) {
  console.info('Editing user account information');
  context.dispatch(Actions.USER_ACCOUNT__EDIT_STARTED);
}

export async function updateAccountInfo(context, payload) {
  context.dispatch(Actions.USER_ACCOUNT__UPDATED, payload);
}

export async function saveAccount(context, user) {
  console.info('Editing user account information');
  const result = await context.service.update('account', {}, {
    type: AccountUpdateTypes.UPDATE_ACCOUNT_INFO,
    user: user
  });
  context.dispatch(Actions.AUTHENTICATION__CHECK_COMPLETED, result.data);
  context.dispatch(Actions.USER_ACCOUNT__EDIT_COMPLETED, {
    saved: true
  });
  const router = context.getRouter();
  router.push('/account/view');
}

export async function cancelAccountEdit(context) {
  console.info('Editing user account information');
  context.dispatch(Actions.USER_ACCOUNT__EDIT_CANCELLED);
}

export async function changeSelectedClient(context, clientKey) {
  const result = await context.service.update('account', {}, {
    type: AccountUpdateTypes.CHANGE_SELECTED_CLIENT,
    clientKey
  });

  if (result.data.selectedClient.key === clientKey) {
    window.location.reload();
    context.dispatch(Actions.USER_ACCOUNT__CLIENT_CHANGED, clientKey);
  }
}

export async function clearMessages(context) {
  console.info('Editing user account information');
  context.dispatch(Actions.USER_ACCOUNT__MESSAGES_CLEARED);
}



// WEBPACK FOOTER //
// ./src/apps/Account/actions/AccountActionCreators.js